/**
 * Store Unavailable Page
 * Displayed when store subscription is expired, suspended, or deactivated
 */

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '../../hooks/useTranslation';

const StoreUnavailable: React.FC = () => {
  const { t } = useTranslation();

  const handleClose = () => {
    const tg = window.Telegram?.WebApp;
    if (tg?.close) {
      tg.close();
    }
  };

  return (
    <Container>
      <Content>
        <IconWrapper>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M3 3h18v18H3V3z" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 9h18" strokeLinecap="round"/>
            <path d="M9 21V9" strokeLinecap="round"/>
            <path d="M12 12.5L14.5 15M14.5 12.5L12 15" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </IconWrapper>
        <Title>{t('shop.storeUnavailable')}</Title>
        <Message>
          {t('shop.storeUnavailableMessage')}
        </Message>
        <CloseButton onClick={handleClose}>
          {t('common.close')}
        </CloseButton>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: var(--tg-theme-bg-color, #1a1a1a);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
`;

const IconWrapper = styled.div`
  color: var(--tg-theme-hint-color, #8e8e93);
  margin-bottom: 24px;
  opacity: 0.6;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: var(--tg-theme-text-color, #ffffff);
  margin: 0 0 12px 0;
`;

const Message = styled.p`
  font-size: 15px;
  color: var(--tg-theme-hint-color, #8e8e93);
  margin: 0 0 32px 0;
  line-height: 1.5;
`;

const CloseButton = styled.button`
  background: var(--tg-theme-button-color, #3390ec);
  color: var(--tg-theme-button-text-color, #ffffff);
  border: none;
  border-radius: 12px;
  padding: 14px 48px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  &:active {
    opacity: 0.8;
  }
`;

export default StoreUnavailable;
